export default __webpack_public_path__ + "static/media/Grey Noise.b4d97a79.jpg";